const timeline = {
	el: {
		containers: document.querySelectorAll('.js-timeline')
	},

	fxDateToTimeStamp (value) {
		const [dd, mm, yyyy] = value.split('/')

		return new Date(yyyy, mm - 1, dd)
	},

	fxSetStyles (container) {
		const cards = container.querySelectorAll('.timeline__card'),
			currentDate = new Date()

		for(const card of cards) {
			const startDate = card.dataset.start !== '' ? this.fxDateToTimeStamp(card.dataset.start) : this.fxDateToTimeStamp('01/01/2000'),
				endDate = card.dataset.end !== '' ? this.fxDateToTimeStamp(card.dataset.end) : this.fxDateToTimeStamp('01/01/2000')

			if(currentDate <= endDate && currentDate >= startDate) {
				card.classList.add('timeline__card--active')
			} else {
				card.classList.remove('timeline__card--active')
			}
		}
	},

	init () {
		if(this.el.containers.length === 0) return
		for (const container of this.el.containers) {
			this.fxSetStyles(container)
		}
		
	}
}

timeline.init()